// @ts-nocheck
import { YStack, XStack, Text, Paragraph } from 'tamagui';
import { Container } from './Container';
import { RomanDivider } from './RomanDivider';

const experience = [
  { company: 'AWS', role: 'L6 control-plane lead, 500+ locations' },
  { company: 'Omni Network', role: 'Cross-chain indexer, 1M+ events/day' },
  { company: 'Solo Funds', role: 'Ledger infra, $50M+/yr — JanusLedger came from it' },
  { company: 'Plaid', role: 'KYC/KYB and risk systems' },
  { company: 'Meta', role: 'Infra at scale, 500M pipeline runs/month' },
];

export function Founder({ theme }) {
  return (
    <YStack paddingVertical="$10">
      <YStack paddingHorizontal="$6">
        <RomanDivider theme={theme} />
      </YStack>

      <Container>
        <XStack flexDirection="row" gap="$10" paddingTop="$6" flexWrap="wrap">
          <YStack gap="$4" flex={1} minWidth={280}>
            <XStack flexDirection="row" alignItems="center" gap="$4">
              <YStack width={40} height={1} backgroundColor="$amber7" />
              <Text fontSize="$2" color="$color7" textTransform="uppercase" letterSpacing={3} fontWeight="500">
                About
              </Text>
            </XStack>

            <Paragraph color="$color10" fontSize="$5" lineHeight={28} maxWidth={480}>
              I'm Dan. Staff engineer, ten years in. A portfolio this size from one
              person is a fair thing to be skeptical about — the answer is that I've
              built most of it before, at companies where it had to hold.
            </Paragraph>
            <Paragraph color="$color7" fontSize="$3" lineHeight={22} maxWidth={480}>
              The Roman naming is real — Classical Antiquities minor at Trinity College.
              Every product is named after something a legionary carried or a Roman
              engineer built.
            </Paragraph>
            <XStack flexDirection="row" gap="$5" marginTop="$2">
              <Text
                fontSize="$3" color="$amber7" fontWeight="500"
                hoverStyle={{ color: '$amber8' }} cursor="pointer"
                onPress={() => window.open('https://github.com/sid-technologies', '_blank')}
              >
                GitHub →
              </Text>
              <Text
                fontSize="$3" color="$amber7" fontWeight="500"
                hoverStyle={{ color: '$amber8' }} cursor="pointer"
                onPress={() => window.open('https://logicalbytes.dev', '_blank')}
              >
                Blog →
              </Text>
            </XStack>
          </YStack>

          <YStack gap="$3" flex={1} minWidth={280}>
            <Text fontSize="$2" color="$color7" textTransform="uppercase" letterSpacing={2} fontWeight="500" marginBottom="$1">
              Previously
            </Text>
            {experience.map((exp) => (
              <XStack key={exp.company} flexDirection="row" alignItems="baseline" gap="$3" paddingVertical="$1" borderBottomWidth={1} borderBottomColor="$color4">
                <Text fontSize="$4" fontWeight="600" color="$color11" fontFamily="Cinzel" minWidth={140} letterSpacing={0.5}>
                  {exp.company}
                </Text>
                <Text fontSize="$3" color="$color7">
                  {exp.role}
                </Text>
              </XStack>
            ))}
          </YStack>
        </XStack>
      </Container>
    </YStack>
  );
}
